import React, { useMemo } from 'react';
import { Marker } from 'react-map-gl';

// Memoized PlayerMarker component
const PlayerMarker = React.memo(
  ({ player, handleSelectPlayer, isMoving }) => {
    // console.log(`PlayerMarker: ${player.playerId} isMoving: ${isMoving}`);
    // if (player.playerId === 'JGMichelle' || player.playerId === 'joegalaxy') {
    //   console.log(`PlayerMarker: ${player.playerId} isMoving: ${isMoving}`);
    // }

    return (
      <Marker
        key={player.playerId}
        longitude={player.lastLocation.coordinates[0]}
        latitude={player.lastLocation.coordinates[1]}
      >
        <button
          className="marker-btn2"
          onClick={(e) => {
            e.preventDefault();
            handleSelectPlayer(player);
          }}
        >
          <img
            src={
              player.profilePhoto
                ? player.profilePhoto
                : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
            }
            alt={player.playerId}
            title={player.playerId}
          />
          {/* Blinking dot for all players */}
          <span
            className={`blinking-dot ${isMoving ? 'green' : 'red'}`}
            style={{
              position: 'absolute',
              top: 2,
              right: 2,
              width: 14,
              height: 14,
              borderRadius: '50%',
              border: '2px solid white',
              zIndex: 2,
              pointerEvents: 'none',
            }}
          />
        </button>
      </Marker>
    );
  },
  (prevProps, nextProps) => {
    // if (
    //   prevProps.player.playerId === 'JGMichelle' ||
    //   prevProps.player.playerId === 'joegalaxy'
    // ) {
    //   console.log(
    //     `Memo condition: PlayerMarker: ${prevProps.player.playerId} isMoving: ${prevProps.isMoving} -> ${nextProps.isMoving}`,
    //   );
    // }
    const locationChanged =
      prevProps.player.lastLocation.coordinates[0] !==
        nextProps.player.lastLocation.coordinates[0] ||
      prevProps.player.lastLocation.coordinates[1] !==
        nextProps.player.lastLocation.coordinates[1];
    const profilePhotoChanged =
      prevProps.player.profilePhoto !== nextProps.player.profilePhoto;
    const isMovingChanged = prevProps.isMoving !== nextProps.isMoving;

    return !locationChanged && !profilePhotoChanged && !isMovingChanged;
  },
);

// Memoized PlayerMarkers component
const PlayerMarkers = React.memo(
  ({ playersWithin, player, handleSelectPlayer, now }) => {
    const filteredPlayers = useMemo(() => {
      return Object.values(playersWithin)
        .sort((a, b) => a.jgkTokens - b.jgkTokens)
        .filter(
          (playerWithin) =>
            player.data.player.friends.includes(playerWithin._id) ||
            playerWithin._id === player.data.player._id,
        );
    }, [playersWithin, player.data.player.friends, player.data.player._id]);

    return (
      <>
        {filteredPlayers.map((thePlayer) => {
          const isMoving =
            thePlayer.lastMovementTime &&
            now - thePlayer.lastMovementTime < 30000;
          return (
            <PlayerMarker
              key={thePlayer.playerId}
              player={thePlayer}
              handleSelectPlayer={handleSelectPlayer}
              isMoving={isMoving}
            />
          );
        })}
      </>
    );
  },
);

export default PlayerMarkers;
